/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M0 5.647C0 2.5284 2.5283 0 5.647 0H18.353C21.4717 0 24 2.5283 24 5.647V18.353C24 21.4717 21.4717 24 18.3529 24H5.6471C2.5283 24 0 21.4717 0 18.3529V5.6471Zm13.0588-3.5294h5.2941c1.9493 0 3.5295 1.5802 3.5295 3.5295v12.7058c0 1.9493-1.5802 3.5295-3.5295 3.5295h-5.2941v-5.8087c1.4319-.4497 2.4706-1.7875 2.4706-3.3678 0-1.9493-1.5802-3.5294-3.5294-3.5294-1.9492 0-3.5294 1.5801-3.5294 3.5294 0 1.5803 1.0387 2.9181 2.4706 3.3678v5.8087H5.6471c-1.9493 0-3.5295-1.5802-3.5295-3.5295V5.6471c0-1.9493 1.5802-3.5295 3.5295-3.5295h5.2941v2.1079c-1.822.2262-3.5852 1.0387-4.984 2.4376-3.3374 3.3373-3.3374 8.7482 0 12.0856.4135.4135 1.0839.4135 1.4974 0s.4135-1.0839 0-1.4974c-2.5104-2.5104-2.5104-6.5805 0-9.0908 2.5103-2.5104 6.5805-2.5104 9.0908 0 2.5104 2.5103 2.5104 6.5804 0 9.0908-.4135.4135-.4135 1.0839 0 1.4974s1.0839.4135 1.4974 0c3.3374-3.3374 3.3374-8.7483 0-12.0856-1.3988-1.3989-3.1619-2.2114-4.984-2.4376V2.1176Zm-1.0588 12c.7797 0 1.4118-.632 1.4118-1.4117S12.7797 11.2941 12 11.2941s-1.4118.6321-1.4118 1.4118.6321 1.4117 1.4118 1.4117Z"
    clipRule="evenodd"
  />,
  'MenuAPIManagement'
);
